<template>
  <div
    class="
      xl:w-4/5
      md:w-11/12
      xl:my-10
      md:my-4
      md:mx-auto
      m-1
      bg-gray-50
      rounded
    "
  >
    <div class="w-full md:px-5 m-auto py-5">
      <!-- Function buttons -->
      <div class="mb-4">
        <t-button @click="toggleGlobalSelection"
          >{{ EnableGlobal ? 'Disable' : 'Enable' }} module Selection</t-button
        >
        &nbsp;&nbsp;
        <t-button @click="toggleCurrentSelection"
          >{{ EnableCurrent ? 'Disable' : 'Enable' }} "Choose Current
          Year"</t-button
        >
        &nbsp;&nbsp;
        <t-button @click="toggleNextSelection"
          >{{ EnableNext ? 'Disable' : 'Enable' }} "Choose Next Year"</t-button
        >
      </div>

      <!-- Message fields -->
      <div class="mb-4">
        <div class="mb-3">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="currentYearMessage">
            Message when "Choose Current Year" is disabled:
          </label>
          <input
            id="currentYearMessage"
            v-model="currentYearMessage"
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Enter message for disabled current year selection"
          />
        </div>
        <div class="mb-3">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="nextYearMessage">
            Message when "Choose Next Year" is disabled:
          </label>
          <input
            id="nextYearMessage"
            v-model="nextYearMessage"
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Enter message for disabled next year selection"
          />
        </div>
        <t-button @click="saveMessages" class="bg-blue-500 hover:bg-blue-700">
          Save Messages
        </t-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      EnableGlobal: true,
      EnableCurrent: true,
      EnableNext: true,
      currentYearMessage: '',
      nextYearMessage: '',
    };
  },
  created() {
    this.getEnabled();
  },
  methods: {
    toggleGlobalSelection: function() {
      this.EnableGlobal = !this.EnableGlobal;
      fetch(
        `${process.env.VUE_APP_API_URL}/toggle_global_selection`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            val: this.EnableGlobal,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    toggleCurrentSelection: function() {
      this.EnableCurrent = !this.EnableCurrent;
      fetch(
        `${process.env.VUE_APP_API_URL}/toggle_current_selection`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            val: this.EnableCurrent,
            message: this.currentYearMessage,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    toggleNextSelection: function() {
      this.EnableNext = !this.EnableNext;
      fetch(
        `${process.env.VUE_APP_API_URL}/toggle_next_selection`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            val: this.EnableNext,
            message: this.nextYearMessage,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    getEnabled: function() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_enabled_selections`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then((r) => {
          return r.json();
        })
        .then((response) => {
          console.log(response.data);
          this.EnableGlobal = response.data[0].module_selection_enabled;
          this.EnableCurrent = response.data[0].current_year_enabled;
          this.EnableNext = response.data[0].next_year_enabled;

          // Set messages if they exist in the response
          if (response.data[0].current_year_message) {
            this.currentYearMessage = response.data[0].current_year_message;
          }
          if (response.data[0].next_year_message) {
            this.nextYearMessage = response.data[0].next_year_message;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveMessages: function() {
      // Send both messages to the backend
      fetch(
        `${process.env.VUE_APP_API_URL}/update_selection_messages`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            currentYearMessage: this.currentYearMessage,
            nextYearMessage: this.nextYearMessage,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then((r) => {
          return r.json();
        })
        .then((response) => {
          console.log('Messages updated:', response);
          // Could add a notification here to show success
        })
        .catch((err) => {
          console.error(err);
          // Could add error handling notification here
        });
    },
  },
};
</script>
